import { render, staticRenderFns } from "./bankcardCheck.vue?vue&type=template&id=9613f04e&scoped=true"
import script from "./bankcardCheck.vue?vue&type=script&lang=js"
export * from "./bankcardCheck.vue?vue&type=script&lang=js"
import style0 from "./bankcardCheck.vue?vue&type=style&index=0&id=9613f04e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9613f04e",
  null
  
)

export default component.exports